const ACCOUNT_META = {
	ACCOUNT_SETUP: "accountSetup",
	CAMPAIGN_WITH_BLUEPRINT: "campaignsWithBlueprint",
	BILLING_SETUP: "billingSetup",
	INDUSTRY_CLASSIFICATION: "industryClassification",
	DKIM_WARNING: "dkimWarning",
};


export { ACCOUNT_META };
